<template>
  <div class="wrapper">
    <div class="topInfo">
       <div class="left">
         <img @click="showImage(item.prize_image)" :src="item.prize_image" alt="">
       </div>
       <div class="right">
         <div class="commodityName twoLine">{{item.prize_name}}</div>
         <div class="property twoLine" v-if="item.prize_type<2">规格：{{item.property_simple}}</div>
       </div>
    </div>
    <div class="bottomInfo">
      <div class="item">
        <div class="headTitle"><span>物流信息</span></div>
        <div class="content">
          <div class="contentItem">
            <span class="title">发货状态：</span><span class="value">{{item.order_state==0?'待发货':'已发货'}}</span>
          </div>
          <div class="contentItem">
            <span class="title">物流公司：</span><span class="value">{{item.express_name||'无'}}</span>
          </div>
          <div class="contentItem">
            <span class="title">物流单号：</span><span class="value">{{item.express_id||'无'}}</span>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="headTitle"><span>收货人信息</span></div>
        <div class="content">
          <div class="contentItem">
            <span class="title">收货人：</span><span class="value twoLine">{{item.contacts}}</span>
          </div>
          <div class="contentItem">
            <span class="title">联系电话：</span><span class="value twoLine">{{item.phone_no}}</span>
          </div>
          <div class="contentItem">
            <span class="title">地址信息：</span><span class="value twoLine">{{item.address}}</span>
          </div>
          <div class="contentItem">
           <span class="title">备注信息：</span><span class="value twoLine">{{item.message||'无'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      item:{},
    }
  },
  watch: {},
  computed: {
  },
  methods: {
    showImage(img) {
      wx.previewImage({
        current: img,
        urls: [img]
      });
    },
  },
  created() {
    let option = {
      title: '有米@'+this.userInfo.name + "的店铺",
      desc: "欢迎光临我的店铺",
      link: location.origin + "/?supNbr=" + this.userInfo.nbr,
      images: this.userInfo.imgUrl
    };
    this.weChatShare(option);
  },
  activated() {},
  mounted() {
    document.title = '详情';
    if(!(this.userInfo&&this.userInfo.nbr)){
      return this.$router.replace({path:'/index',query:{supNbr:this.userInfo.nbr}});
    }
    let toast = this.$toast.loading({
      mask: false,
      duration: 0
    });
    this.$commonPost({
      jydm: "flow_90016",
      flow_90016: {
        user_nbr: this.userInfo.nbr,
        game_nbr: this.$route.query.game,
        record_nbr: this.$route.query.record,
      }
    })
      .then(response => {
        this.item = response;
        toast.clear();
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
}
</script>
<style scoped lang='stylus'>
</style>
<style scoped lang='less'>
.twoLine{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
  white-space: normal;
}
.wrapper{
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
}
.topInfo{
  width: 100%;
  height: 2.5rem;
  background: #fff;
  padding: .5rem .24rem;
  border-radius: 0 0 .2rem .2rem;
  box-sizing:border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left{
    width: 1.5rem;
    height: 1.5rem;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .right{
    width: calc(100% - 1.7rem);
    height: 1.5rem;
    .commodityName{
      width: 100%;
      line-height: .32rem;
      font-size: 0.24rem;
      color: #333;
      font-weight: bold;
    }
    .property{
      width: 100%;
      line-height: .3rem;
      margin-top: .1rem;
      font-size: 0.22rem;
      color: #999;
    }
  }
}
.bottomInfo{
  width: 100%;
  padding: .2rem .24rem 2.54rem;
  box-sizing: border-box;
  .item{
    width: 100%;
    background: #fff;
    box-shadow: 0 .02rem .14rem 0 rgba(51,51,51,0.06);
    border-radius: .18rem;
    margin-bottom: .1rem;
    .headTitle{
      width: 100%;
      height: .88rem;
      box-sizing: border-box;
      padding-left: .44rem;
      position: relative;
      span{
        left: .44rem;
        top: 50%;
        position: absolute;
        font-size: .56rem;
        color: #333;
        font-weight: bold;
        transform: scale(0.5) translateY(-50%);
        transform-origin: 0% 0%;
      }
    }
    .headTitle::before{
      content: '';
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      width: .06rem;
      height: .28rem;
      background: #E52B25;
      left: .24rem;
    }
    .content{
      border-top:1px solid #eee;
      padding: 0 0 .06rem;
      .contentItem:first-child{
        margin-top: 0.1rem;
      }
      .contentItem{
        width: 100%;
        box-sizing: border-box;
        padding: 0 .44rem;
        margin-bottom: .2rem;
        display: flex;
        align-items: flex-start;
        span{
          font-size: .24rem;
          color: #333;
          font-weight: 500;
          line-height: .33rem;
          margin-top: 0.08rem;
        }
        .title{
          width: 1.2rem;
          display: inline-block;
        }
        .value{
          flex:1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/rewardDetail.vue